import Vue from "vue";
import VueRouter from "vue-router";
import Supplier from "../views/Supplier.vue";
import Customer from "../views/Customer.vue";
import Home from "../views/Home.vue";
import Search from "../views/Search.vue";
import Account from "../views/Account/Account.vue";
import About from "../views/About.vue";
import Features from "../views/Features.vue";
import CompanyInfo from "../views/Account/Pages/CompanyInfo.vue";
import Team from "../views/Account/Pages/Team.vue";
import PersonalInfo from "../views/Account/Pages/PersonalInfo.vue";
import Billing from "../views/Account/Pages/Billing.vue";
import Password from "../views/Account/Pages/Password.vue";
import Orders from "../views/Account/Pages/Orders.vue";
import Order from "../views/Account/Pages/Order.vue";
import Favourite from "../views/Account/Pages/Favourite.vue";
import Basket from "../views/Basket.vue";
import Product from "../views/Product.vue";
import Checkout from "../views/Checkout.vue";
import Confirmation from "../views/Confirmation.vue";
//import Login from "../views/Auth/Login.vue";
import AcceptInvite from "../views/AcceptInvite.vue";
import ResetPassword from "../views/ResetPassword.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import TrackOrder from "../views/TrackOrder.vue";
import auth from "@/auth/auth.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/supplier",
    name: "Supplier",
    component: Supplier
  },
  {
    path: "/customer",
    name: "Customer",
    component: Customer
  },
  {
    path: "/home",
    name: "Home",
    component: Home
  },
  {
    path: "/search",
    name: "Search",
    component: Search
  },
  {
    path: "/search/:category/:subcategory/:id",
    name: "search-category-subcategory",
    component: Search,
    props: true
  },
  {
    path: "/features",
    name: "Features",
    component: Features
  },
  {
    path: "/reset-password/:id",
    name: "ResetPassword",
    component: ResetPassword,
    props: true
  },
  {
    path: "/about",
    name: "About",
    component: About
  },
  {
    path: "/contact",
    name: "Contact",
    component: Home
  },
  {
    path: "/basket",
    name: "Basket",
    component: Basket
  },
  {
    path: "/product/:id",
    name: "Product",
    component: Product,
    props: true
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: Checkout
  },
  {
    path: "/confirmation",
    name: "Confirmation",
    component: Confirmation
  },
  {
    path: "/track_shipment",
    name: "TrackOrder",
    component: TrackOrder
  },
  {
    path: "/account",
    name: "Account",
    component: Account,
    redirect: "/account/personal-info",
    children: [
      {
        path: "company-info",
        name: "company-info",
        component: CompanyInfo,
        meta: {
          requiresSurgery: true
        }
      },
      {
        path: "team",
        component: Team,
        name: "Team",
        meta: {
          requiresSurgery: true
        }
      },
      {
        path: "personal-info",
        name: "personal-info",
        component: PersonalInfo
      },
      {
        path: "billing",
        name: "billing",
        component: Billing
      },
      {
        path: "password",
        name: "change-password",
        component: Password
      },
      {
        path: "orders",
        name: "orders",
        component: Orders
      },
      {
        path: "orders/:id",
        name: "order",
        component: Order,
        props: true
      },
      {
        path: "favourite",
        name: "favourite",
        component: Favourite
      }
    ]
  },
  {
    path: "/accept-invite/:id",
    name: "accept-invite",
    component: AcceptInvite,
    props: true
  },
  {
    path: "/login",
    name: "Home",
    component: Home
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  history: true
});

// router.beforeEach((to, from, next) => {
//   if (to.meta.requiresSurgery) {
   

//    if (!auth.tokenIsValid(VueCookie.get("token"))) {
//       alert('i next')
//       next("/login");
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });

router.beforeEach((to, from, next) => {
  console.log(to);
  if (to.path !== '/login' && !auth.tokenIsValid() || to.meta.requiresSurgery && !auth.tokenIsValid()) {
    localStorage.setItem('to', to.path)
    next({ path: '/login' });
  } else if (to.path === '/login') {
    next();
  } 
  next();
});

export default router;
